/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Setpoint_Input_ModeInputs */



/**
* | output |
* | --- |
* | "Temperature input mode" |
*
* @param {Air_Handler_Unit_Setpoint_Input_ModeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_setpoint_input_mode = /** @type {((inputs?: Air_Handler_Unit_Setpoint_Input_ModeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Setpoint_Input_ModeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Temperature input mode")
	return /** @type {LocalizedString} */ ("Mode de saisie des températures")
});